/*
 * jQuery Standalone - Loaded with defer via scripts.isml
 * Includes all heavy plugins to avoid duplication in other bundles
 */

'use strict';

window.jQuery = window.$ = require('jquery');

// Load all heavy plugins here (one-time load)
require('slick-carousel/slick/slick');
require('bootstrap-select/dist/js/bootstrap-select');
require('bootstrap/js/src/collapse.js');
require('bootstrap/js/src/dropdown.js');
require('bootstrap/js/src/modal.js');
require('bootstrap/js/src/tab.js');
require('bootstrap/js/src/tooltip.js');
require('bootstrap/js/src/alert.js');